import {
  FilterQuery,
  SaF,
  SaFLegend,
  SkeletonDots
} from '@yes.technology/react-toolkit'
import { useEffect, useId } from 'react'
import SectionDivider from '../SectionDivider'
import { useSiteState } from 'siteState/shared'
import useSaFQuery from './useSaFQuery'
import AppliedFilters, {
  AppliedFiltersProps
} from '../AppliedFilters/AppliedFilters'
import { LegendsContainer } from './SafChartFilter.styles'
import { useSearchParams } from 'react-router-dom'
import { useSitemodel } from 'sitemodel/shared/hooks'

type SaFChartFilterProps = {
  props: {
    static_input?: React.ComponentProps<typeof SaF>
    static_dates?: AppliedFiltersProps
  }
}

export default function SaFChartFilter({
  props: { static_input: staticInput, static_dates }
}: SaFChartFilterProps) {
  const sitemodel = useSitemodel()

  const title = sitemodel.title || ''

  const sectionId = useId()

  const [filterQuery] = useSiteState<FilterQuery | undefined>('filter-query')

  const [objectclassUuidInState] = useSiteState<string | undefined>(
    'objectclassuuid'
  )
  const [searchParams] = useSearchParams()
  const objectclassUuid =
    searchParams.get('uuid_objectclass') || objectclassUuidInState || ''

  const {
    isFetching,
    data,
    error: requestError
  } = useSaFQuery({
    filterQuery: staticInput ? undefined : filterQuery,
    objectclassUuid
  })

  const input = staticInput || data
  const emptyNodesError =
    input && input.data.nodes.length < 1
      ? new Error('SaF data for nodes is empty')
      : null

  const error = emptyNodesError || requestError

  useEffect(() => {
    if (error) {
      console.error(error)
    }
  }, [error])

  if (!filterQuery || (!staticInput && !isFetching && !data)) {
    return null
  }

  return (
    <SectionDivider
      id={sectionId}
      title={title}
      centerHeaderElement={<>SaF Chart</>}
      backgroundColor='#004099'
    >
      {input && !emptyNodesError ? (
        <>
          <SaF {...input} />
          <LegendsContainer>
            <SaFLegend />
            <AppliedFilters {...static_dates} />
          </LegendsContainer>
        </>
      ) : (
        <SkeletonDots size={12} className='justify-content-center' />
      )}
    </SectionDivider>
  )
}
